import React from 'react';
import { Switch, Route } from 'react-router-dom';

const AdminView = React.lazy(() => import('./views/AdminView'));
const AdminUsers = React.lazy(() => import('./views/AdminUsers'));

function Routes() {
  return (
    <Switch>
      <Route exact path="/dashboard/permisos" component={AdminView} />
      <Route exact path="/dashboard/permisos/usuario" component={AdminUsers} />
    </Switch>
  );
}

export default Routes;
